module.exports = __webpack_public_path__ + "img/06-0资质10.b0c892fb.png";